<template lang="html">
  <div class="fill-height">
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
            <div class="mt-4">
              <template v-if="$store.state.selected_outlet">
                <div class="col-image-circle">
                  <img :src="$store.state.selected_outlet.logo" :alt="$store.state.selected_outlet.name" class="image-responsive">
                </div>
              </template>
            </div>
            <div class="mt-4 font-24 font-weight-bold ol-black text-center">
              {{ $t('v2.hallo') }}
            </div>
            <div class="mt-8 font-16 ol-black">
              {{ $t('v2.make_ordering_easier_please_enter_your_name') }}
            </div>
            <div class="mt-4">
              <label class="font-12">{{ $t('v2.name') }}</label>
              <ValidationProvider v-slot="{ errors, valid }" name="name" rules="required">
                <v-text-field v-model="form.name" outlined heigth="40" dense :error-messages="errors" class="inputv2-space" />
              </ValidationProvider>
            </div>
            <div>
              <label class="font-12">{{ $t('v2.gender') }}</label>
              <ValidationProvider v-slot="{ errors, valid }" name="gender" rules="required">
                <v-select v-model="form.gender" :items="gender" outlined heigth="40" item-value="id" item-text="name" :menu-props="{ offsetY: true }" dense :error-messages="errors" class="inputv2-space" />
              </ValidationProvider>
            </div>
            <div class="section-bottom">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                    <v-btn block color="primary" height="40" class="text-none br-5" @click="addAccount()">
                      {{ $t('v2.next') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </ValidationObserver>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  completeProfile
} from '@/api/auth'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      form: {
        name: '',
        gender: ''
      },
      gender: [
        { id: 'M', name: 'Laki-laki' },
        { id: 'F', name: 'Perempuan' }
      ]
    }
  },
  methods: {
    goBack() {
      const query = this.$route.query.redirect
      if (query) {
        if (query === 'order') {
          this.$router.push({ name: query, params: { id: this.$route.query.id }}).catch(() => {})
        } else {
          this.$router.push({ name: query }).catch(() => {})
        }
      } else {
        this.$router.go(-1)
      }
    },
    async addAccount() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          await completeProfile(this.form)
          const query = this.$route.query.redirect
          if (query) {
            if (query === 'order') {
              this.$router.push({ name: query, params: { id: this.$route.query.id }}).catch(() => {})
            } else if (query === '_checkout') {
              this.$router.push({ name: query, query: { user_type: 'new', user_name: this.form.name }}).catch(() => {})
            } else {
              this.$router.push({ name: query }).catch(() => {})
            }
          } else {
            this.$router.push({ name: '_splash' }).catch(() => {})
          }
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
}
</script>
